import { cn } from "@/lib/utils";

interface SectionLabelProps {
  children: React.ReactNode;
  className?: string;
  light?: boolean; // use on dark backgrounds
}

/**
 * Eyebrow label rendered above section headings.
 * DM Sans, uppercase, tracked, muted color.
 */
export function SectionLabel({ children, className, light = false }: SectionLabelProps) {
  return (
    <p
      className={cn(
        "text-xs font-medium uppercase tracking-[0.07em] font-[DM_Sans] mb-3",
        light ? "text-white/50" : "text-[#888888]",
        className
      )}
    >
      {children}
    </p>
  );
}
